import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {Link, useHistory} from 'react-router-dom';
import {toast} from 'react-toastify';
import {useFormik} from 'formik';
import {useTranslation} from 'react-i18next';
import {loginUser} from '@store/reducers/auth';
import {Button, Checkbox, Input} from '@components';
import {faEnvelope, faLock} from '@fortawesome/free-solid-svg-icons';

import * as Yup from 'yup';

import * as UserService from '@app/services/UserService';
import {LOCAL_STORAGE_AUTH_TOKEN, LOCAL_STORAGE_USER_LOGIN_INFO, ResponseCode} from '@app/constants/Common';

const Login = () => {
    const [isAuthLoading, setAuthLoading] = useState(false);
    const [isGoogleAuthLoading, setGoogleAuthLoading] = useState(false);
    const [isFacebookAuthLoading, setFacebookAuthLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const dispatch = useDispatch();

    const history = useHistory();
    const [t] = useTranslation();

    const login = async (username, password) => {
        // try {
        //     setAuthLoading(true);
        //     const token = await UserService.requestLogin(email, password);
        //     toast.success('Login is succeed!');
        //     setAuthLoading(false);
        //     dispatch(loginUser(token));
        //     history.push('/');
        // } catch (error) {
        //     setAuthLoading(false);
        //     toast.error(error.message || 'Failed');
        // }
        setAuthLoading(true);
        setErrorMessage("");
        UserService.requestLogin({username: username, password: password}).then((res) => {
            console.log(JSON.stringify(res))
            if (res.sts_code === ResponseCode.SUCCESS) {
                localStorage.setItem(LOCAL_STORAGE_AUTH_TOKEN, res.content.token);
                localStorage.setItem(LOCAL_STORAGE_USER_LOGIN_INFO, JSON.stringify(res.content));
                // requestFirebaseToken()
                // onMessageListener()
                toast.success(`Đăng nhập thành công.`);
                history.push('/');
            } else if (res.sts_code === ResponseCode.REQUIRE_TO_CHANGE_PASSWORD) {
                history.push('/change-password');
            } else {
                setErrorMessage(res.message);
            }
        }).catch((error) => {
            // toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        }).finally(() => {
            setAuthLoading(false);
        })
    };

    const formik = useFormik({
        initialValues: {
            username: '',
            password: ''
        },
        validationSchema: Yup.object({
            username: Yup.string()
                // .email('Invalid user name')
                .required('Required'),
            password: Yup.string()
                // .min(8, 'Must be 8 characters or more')
                // .max(30, 'Must be 30 characters or less')
                .required('Required')
        }),
        onSubmit: (values) => {
            login(values.username, values.password);
        }
    });

    document.getElementById('root').classList = 'hold-transition login-page';

    return (
        <div className="login-box">
            <div className="card card-outline card-primary">
                <div className="card-header text-center">
                    <Link to="/" className="h1">
                        <b>GOPA </b>
                        <span>CRM</span>
                    </Link>
                </div>
                <div className="card-body">
                    <p className="login-box-msg">{t('login.label.signIn')}</p>
                    <p className={'text-danger'}>{errorMessage}</p>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="mb-3">
                            <Input
                                icon={faEnvelope}
                                placeholder="Tên đăng nhập"
                                type="text"
                                formik={formik}
                                formikFieldProps={formik.getFieldProps('username')}
                            />
                        </div>
                        <div className="mb-3">
                            <Input
                                icon={faLock}
                                placeholder="Password"
                                type="password"
                                formik={formik}
                                formikFieldProps={formik.getFieldProps(
                                    'password'
                                )}
                            />
                        </div>

                        <div className="row">
                            <div className="col-6">
                                <Checkbox
                                    checked={false}
                                    label={t('login.label.rememberMe')}
                                />
                            </div>
                            <div className="col-6 text-right">
                                <Link to='/reset-password'>
                                    Quên mật khẩu?
                                </Link>
                            </div>
                            <div className="col-8 mt-3">
                                <Button
                                    block
                                    type="submit"
                                    isLoading={isAuthLoading}
                                    disabled={
                                        isFacebookAuthLoading ||
                                        isGoogleAuthLoading
                                    }
                                >
                                    {t('login.button.signIn.label')}
                                </Button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Login;
